<script setup>
import { useI18n } from 'vue-i18n'
import { CloudOff } from 'lucide-vue-next'
import { useOnline } from '@/composables/useOnline.js'

const { t } = useI18n()
const { online } = useOnline()
</script>

<template>
  <!--
    The outer element is a persistent, always-mounted live region (present from initial
    render, before the browser has ever gone offline), not just this component's whole
    subtree gated behind `v-if`. A screen reader's live-region observer only reliably
    announces a *mutation inside* a region it already knows about — a region whose
    `aria-live` attribute and text both appear in the same DOM insertion is easy to miss.
    `class="contents"` keeps it out of layout entirely when empty, so it costs nothing
    visually while online.
  -->
  <div
    aria-live="polite"
    class="contents"
  >
    <div
      v-if="!online"
      data-testid="banner"
      role="status"
      class="sticky top-0 z-40 flex items-center justify-center gap-2 bg-blush px-4 py-2 text-sm"
    >
      <CloudOff
        class="size-4"
        aria-hidden="true"
      />
      {{ t('offline.banner') }}
    </div>
  </div>
</template>
